import { createQueryClient } from "./queries";

/**
 * THE query client, as a module singleton.
 *
 * It used to be created in `main.tsx` and handed to the provider. The router
 * needs it too now: a legacy URL (`/admin`, `/overlay/1`) redirects to the
 * registered slug of the legacy event, which is one registry read the route's
 * `beforeLoad` makes through the same cache the pages use. One instance, two
 * importers, no router context plumbing.
 */
export const queryClient = createQueryClient();
